export default {
  fontFamily: ['Calibre', '-apple-system', 'system-ui', 'BlinkMacSystemFont', 'Arial', 'sans-serif'].join(','),
  h1: {
    fontFamily: 'CalibreMedium',
    fontSize: 60,
  },
  h2: {
    fontFamily: 'CalibreMedium',
    fontSize: 48,
  },
  h3: {
    fontFamily: 'CalibreMedium',
    fontSize: 36,
  },
  h4: {
    fontFamily: 'CalibreMedium',
    fontSize: 24,
  },
  h5: {
    fontFamily: 'CalibreMedium',
    fontSize: 18,
  },
  body1: {
    fontSize: 24,
    lineHeight: '1.6',
  },
  body2: {
    fontSize: 18,
    lineHeight: '1.6',
  },
  body3: {
    fontFamily: ['Calibre', '-apple-system', 'system-ui', 'BlinkMacSystemFont', 'Arial', 'sans-serif'].join(','),
    fontSize: '1rem',
    lineHeight: '1.43',
  },
  fullHeroMarkdown: {
    fontSize: 20,
    lineHeight: '1.6',
  },
  button: {
    fontFamily: 'CalibreMedium',
    fontSize: 18,
  },
  caption: {
    fontSize: 16,
    fontFamily: 'CalibreMedium',
  },
  formTitle: {
    fontSize: '2rem',
    lineHeight: '1.3',
  },
};
